/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Details_Agent_Policy_Updated_DescInputs */



/**
* | output |
* | --- |
* | "The organization's agent defaults or limits were changed." |
*
* @param {Audit_Details_Agent_Policy_Updated_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_agent_policy_updated_desc = /** @type {((inputs?: Audit_Details_Agent_Policy_Updated_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Agent_Policy_Updated_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Standardwerte oder Grenzen der Organisation für Agenten wurden geändert.")
	return /** @type {LocalizedString} */ ("The organization's agent defaults or limits were changed.")
});